import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import {
  List,
  TextField,
  EditButton,
  Datagrid,
  SimpleList,
  ReferenceField,
  FunctionField,
  TopToolbar,
  CreateButton,
} from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { MOBILE_BREAKPOINT, SESSIONS } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import AcademicSessionsListFilters from "./ListFilters";
import FinalizeButton from "./components/FinalizeButton";
import { SessionExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";
import { tenants } from "utils/tenants";
import { administrationRequests } from "api/administrationApi";

const ListAcademicSessions = ({ onlySessions }) => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const UserPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={SessionExporter(SESSIONS)} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Академични сесии"
      actions={<ListActions hasCreate={checkPermission(UserPermissions, permissions.canCreateAcademicSessions)} />}
      filters={<AcademicSessionsListFilters />}
      filter={{ onlySessions: onlySessions }}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Тип", value: record.typeText }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Академична година", value: record.academicYearName }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Вид на обучение",
                    value: (
                      <ReferenceField
                        source="studyTypeId"
                        reference={administrationRequests.getStudyTypesSelect()}
                        label="Вид на обучение"
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow fields={[{ label: "Стартира на", value: record.startsOnFormatted }]} />
              <MobileListRow fields={[{ label: "Приключва на", value: record.endsOnFormatted }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Статус",
                    value:
                      record.startsInDays > 0
                        ? `Предстоящ (след ${record.startsInDays} дни)`
                        : record.endsInDays > 0
                          ? `Текущ (остават ${record.endsInDays} дни)`
                          : "Завършен",
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Структурна единица",
                    value: (
                      <ReferenceField
                        source="structuralUnitId"
                        reference={administrationRequests.getStructuralUnitsSelect()}
                        label="Структурна единица"
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              {settings.tenant === tenants.MU && (
                <MobileListRow
                  fields={[
                    {
                      label: "Език на обучение",
                      value: (
                        <ReferenceField
                          source="instructionLanguageId"
                          reference={administrationRequests.getInstructionLanguagesSelect()}
                          label="Език на обучение"
                        >
                          <TextField source="name" />
                        </ReferenceField>
                      ),
                    },
                  ]}
                />
              )}
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canUpdateAcademicSessions}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canFinalizeAcademicSessions}>
                <FinalizeButton isMobile={isMobile} />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="typeText"
            label="Тип"
            sortable={false}
          />

          <TextField
            source="academicYearName"
            label="Академична година"
            sortable={false}
          />

          <ReferenceField
            source="studyTypeId"
            reference={administrationRequests.getStudyTypesSelect()}
            label="Вид на обучение"
          >
            <TextField source="name" />
          </ReferenceField>

          <TextField
            label="Стартира на"
            source="startsOnFormatted"
            sortable={false}
          />

          <TextField
            label="Приключва на"
            source="endsOnFormatted"
            sortable={false}
          />

          <FunctionField
            label="Статус"
            render={record =>
              record.startsInDays > 0
                ? `Предстоящ (след ${record.startsInDays} дни)`
                : record.endsInDays > 0
                  ? `Текущ (остават ${record.endsInDays} дни)`
                  : "Завършен"
            }
          />

          <ReferenceField
            source="structuralUnitId"
            reference={administrationRequests.getStructuralUnitsSelect()}
            label="Структурна единица"
          >
            <TextField source="name" />
          </ReferenceField>
          {settings.tenant === tenants.MU && (
            <ReferenceField
              source="instructionLanguageId"
              reference={administrationRequests.getInstructionLanguagesSelect()}
              label="Език на обучение"
            >
              <TextField source="name" />
            </ReferenceField>
          )}

          <SecuredComponent permission={permissions.canUpdateAcademicSessions}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canFinalizeAcademicSessions}>
            <FinalizeButton isMobile={isMobile} />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};
export default ListAcademicSessions;
